export const base64Decoder = {
    convert(input) {
        return getAtob()(input);
    },
};

export const base64UrlDecode = (str) => {
    const base64 = str.replace(/-/g, '+').replace(/_/g, '/');

    return decodeURIComponent(
        base64Decoder
            .convert(base64)
            .split('')
            .map((char) => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`)
            .join('')
    );
};

export const getAtob = () => {
    // browser
    if (typeof window !== 'undefined' && typeof window.atob === 'function') {
        return window.atob;
    }

    // Next.js global polyfill
    if (typeof atob === 'function') {
        return atob;
    }

    return undefined;
};
